
import axios from 'axios';

// 🌍 Base URL (Dev + Production)
const BASE_URL =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production'
        ? 'https://app.platypusbox.com/api'
        : 'http://localhost:5000/api');

// 🔥 Create Axios Instance
const API = axios.create({
    baseURL: BASE_URL,
    withCredentials: true, // if using cookies (optional)
    timeout: 15000,
});

// 🔐 REQUEST INTERCEPTOR (Attach Token)
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// 🔁 RESPONSE INTERCEPTOR (Handle Errors + Refresh Token)
API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // ❌ If no response (network error)
        if (!error.response) {
            console.error('Network error:', error);
            return Promise.reject(error);
        }

        const { status } = error.response;

        // 🔐 Handle Unauthorized (Token expired)
        if (status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // 👉 OPTIONAL: refresh token API
                const refreshToken = localStorage.getItem('refreshToken');

                if (refreshToken) {
                    const res = await axios.post(`${BASE_URL}/auth/refresh`, {
                        refreshToken,
                    });

                    const newToken = res.data.token;

                    localStorage.setItem('token', newToken);

                    // Retry original request
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    return API(originalRequest);
                }
            } catch (refreshError) {
                console.error('Refresh token failed:', refreshError);

                // 🚪 Logout user
                localStorage.removeItem('token');
                localStorage.removeItem('refreshToken');

                window.location.href = '/login';
            }
        }

        // 🚫 Forbidden
        if (status === 403) {
            console.warn('Access denied:', error.response.data?.message);
        }

        // 🔥 Server error
        if (status >= 500) {
            console.error('Server error:', error.response.data);
        }

        return Promise.reject(error);
    }
);

export default API;